import React, { ChangeEvent, Component } from 'react';
import { RootState } from '../../../../../redux/store';
import { changeApiVariable, changeApiVariableAuth } from '../../../../../redux/actions/ApiVariableActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import FormicaInput from 'components/custom/FormicaInput';
import FormicaLabel from '../../../../custom/FormicaLabel';
import { b64DecodeUnicode, b64EncodeUnicode } from '../../../../../util/Generator';
import CustomPasswordInput from '../../../../custom/CustomPasswordInput';
import ComponentName from '../../../../../constant/ComponentName';

class BasicAuthComponent extends Component<Props> {
  public state = new State();

  render() {
    const { username, password } = this.state;
    const { disabled } = this.props;
    return (
      <div className={'w-full h-full flex flex-col items-center justify-start gap-y-2'}>
        <div className={'flex flex-col w-full gap-y-2'}>
          <FormicaLabel label={'Username'} />
          <FormicaInput
            disabled={disabled}
            onChange={(e: ChangeEvent<HTMLInputElement>) => this.onUsernameChange(e)}
            value={username}
            label={'Username'}
            data-testid={`${ComponentName.API_VARIABLE}_basic_auth_username_input`}
          />
        </div>
        <div className={'flex flex-col w-full gap-y-2 '}>
          <FormicaLabel label={'Password'} />
          <CustomPasswordInput
            disabled={disabled}
            onChange={(e: ChangeEvent<HTMLInputElement>) => this.onPasswordChange(e)}
            value={password}
            label={'Password'}
            data-testid={`${ComponentName.API_VARIABLE}_basic_auth_password_input`}
          />
        </div>
      </div>
    );
  }

  public componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
    const { base64 } = this.state;
    if (prevState.base64 !== base64) {
      const {
        changeApiVariable,
        apiVariable: { apiVariable },
      } = this.props;
      apiVariable.headers['Authorization'] = 'Basic ' + base64;
      changeApiVariable(apiVariable);
    }
  }

  public componentDidMount() {
    const {
      apiVariable: { apiVariable },
    } = this.props;
    const base64 = apiVariable.headers['Authorization']?.split('Basic ');
    if (base64 && base64.length > 1) {
      const decoded = b64DecodeUnicode(base64[1]);
      const [username, password] = decoded.split(':');
      this.setState({ username, password });
    }
  }

  private onUsernameChange(e: ChangeEvent<HTMLInputElement>) {
    this.setState({ username: e.currentTarget.value });
    const value = e.currentTarget.value + ':' + this.state.password;
    const encode = b64EncodeUnicode(value);
    this.setState({ base64: encode });
  }

  private onPasswordChange(e: ChangeEvent<HTMLInputElement>) {
    this.setState({ password: e.currentTarget.value });
    const value = this.state.username + ':' + e.currentTarget.value;
    const encode = b64EncodeUnicode(value);
    this.setState({ base64: encode });
  }
}

interface Props extends ReduxProps {
  disabled?: boolean;
}

class State {
  username: string = '';
  password: string = '';
  base64: string = '';
}

const mapStateToProps = (state: RootState) => ({
  apiVariable: state.apiVariable,
  isUpdate: state.apiVariable.isUpdate,
  auth: state.apiVariable.auth,
});

const mapDispatchToProps = { changeApiVariable, changeApiVariableAuth };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(BasicAuthComponent);
